module.exports = __webpack_public_path__ + "img/671-38f954.png";